import { EmailSendEventV2 } from '../email/event';
import { PermissionEvents } from '@iwentsourcing/core/runtime/runtime-result.js';

export const groupOutputs = {
  'email-send': EmailSendEventV2,
  ...PermissionEvents,
};

export type GroupOutputs = typeof groupOutputs;
